import React, { useState, useEffect } from 'react';
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Chip,
  CircularProgress,
  Pagination,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const PortalPurchases = () => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchPurchases();
  }, [page]);

  const fetchPurchases = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('portal_access_token');
      const response = await api.get(`/portal/purchases?page=${page}&per_page=20`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setPurchases(response.data.purchases || []);
      setTotalPages(response.data.pages || 1);
    } catch (error) {
      console.error('Failed to fetch purchases:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending': return 'warning';
      case 'ready': return 'info';
      case 'completed': return 'success';
      default: return 'default';
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        My Purchases
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        View your purchase history and pickup status
      </Typography>

      {purchases.length > 0 ? (
        <>
          <Grid container spacing={2}>
            {purchases.map((purchase) => (
              <Grid item xs={12} key={purchase.id}>
                <Card sx={{ cursor: 'pointer' }} onClick={() => navigate(`/portal/purchases/${purchase.id}`)}>
                  <CardContent>
                    <Grid container spacing={2} alignItems="center">
                      {purchase.item?.photos?.[0] && (
                        <Grid item xs={12} sm={2}>
                          <Box
                            component="img"
                            src={`${process.env.REACT_APP_API_URL || 'https://api.paceestate.com'}${purchase.item.photos[0].file_path}`}
                            alt={purchase.item.name}
                            sx={{ width: '100%', height: 100, objectFit: 'cover', borderRadius: 1 }}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={5}>
                        <Typography variant="h6">{purchase.item?.name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {purchase.sale?.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Purchased: {new Date(purchase.purchased_at).toLocaleDateString()}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Chip
                          label={`Pickup: ${purchase.pickup_status}`}
                          color={getStatusColor(purchase.pickup_status)}
                          size="small"
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <Typography variant="h6" color="primary" align="right">
                          ${purchase.total_amount}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(e, value) => setPage(value)}
                color="primary"
              />
            </Box>
          )}
        </>
      ) : (
        <Typography color="text.secondary">
          You haven't made any purchases yet. Browse our sales to find great items!
        </Typography>
      )}
    </Box>
  );
};

export default PortalPurchases;
